<template>
    <div class=" shadow-sm p-3 mb-3">
        <div class="text-white text-center" :class="order.validated ? 'bg-success' : 'bg-primary'">
            <h5>Commande Référence Nº : <span class="fw-bold">{{ reference }}</span></h5>
        </div>
        <div class="">
            <!-- <vue-action-buttons :buttons="buttons" /> -->


            <!-- Customer Info -->
            <div class="row">
                <div class="col-md-4">
                    <ul class="list-unstyled">
                        <li>Client :<strong class="fw-bold"> {{ order.customerFullName }} </strong></li>
                        <li>Nº Téléphone :<strong class="fw-bold"> {{ order.customerPhone }} </strong></li>
                        <li>Société :<strong class="fw-bold"> {{ order.customerSociety }} </strong></li>
                    </ul>
                </div>
                <!-- Order Amounts -->
                <div class="col-md-4">
                    <ul class="list-unstyled">
                        <li>Quantité Totale :<strong class="fw-bold"> {{ order.totalQuantity }}</strong></li>
                        <li>Total TTC :<strong v-show="$userRole != 'Magasinier'" class="fw-bold"> {{
                                order.totalPriceTTC }}</strong></li>
                        <!-- <li>Total HT :<strong class="fw-bold"> {{ order.totalPriceHT }}</strong></li>
                        <li>Total TVA :<strong class="fw-bold"> {{ order.totalPriceTVA }}</strong></li> -->
                    </ul>
                </div>
                <!-- Payment Info -->
                <div class="col-md-4">
                    <ul class="list-unstyled">
                        <li>Total Payé :<strong v-show="$userRole != 'Magasinier'" class="fw-bold"> {{ order.amountPaid
                                }}</strong></li>
                        <li>Montant Impayé :<strong v-show="$userRole != 'Magasinier'" class="fw-bold"> {{
                                order.amountUnpaid }}</strong></li>
                    </ul>
                </div>
            </div>

            <!-- Delivery Info -->
            <div class="row mt-3">
                <div class="col-md-6">
                    <ul class="list-unstyled">
                        <li>État :<strong class="fw-bold">{{ order.deliveryFullName != null ? "Livré" : "Non Livré"
                                }}</strong> </li>
                        <li>Livré par :<strong class="fw-bold"> {{ order.deliveryFullName }}</strong> </li>
                        <li>Entreé le :<strong class="fw-bold"> {{ order.startChargeDatetime }}</strong> </li>
                        <li>Livré le :<strong class="fw-bold"> {{ order.deliveryDateTime }}</strong> </li>
                        <li> Véhicule :<strong class="fw-bold"> {{ order.vehicleFullName }}</strong> </li>
                        <li> Poid B :<strong class="fw-bold"> {{ order.grossWeight }}</strong> </li>
                        <li> Poid T :<strong class="fw-bold"> {{ order.tareWeight }}</strong> </li>
                        <li> Laissez-passer Nº :<strong class="fw-bold"> {{ order.passPermit }}</strong> </li>
                        <li> Remarque :<strong class="fw-bold"> {{ order.remark }}</strong> </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
        reference: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            

        }
    },
    methods: {
        
    },
};
</script>

<style scoped>
.card {
    border-radius: 0.75rem;
}
</style>
